module.exports = __webpack_public_path__ + "static/review3-min-1cd9a5ddcfa5f4eccb67e5a210629453.webp";